import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { LeadTaskStatus } from "../constants/leadTaskStatus"
import { LeadTaskType } from "../constants/leadTaskType"
import { FileAttachment } from "@/modules/tasks/customer/models/fileAttachment"
import { LeadResponsibleModel } from "@/modules/lead/models/leadResponsibleModel"
import { LeadNoteModel } from "@/modules/lead/models/leadNoteModel"
import { TaskStatus } from "@/modules/tasks/constants/taskStatus"

@Serializable
export class LeadTaskModel {
  uid: string = ""
  name: string = ""
  description: string = ""
  customerId: string = ""
  customerName: string = ""
  companyVat: string = ""
  companyCountry: string = ""
  customerDeadline: string = ""
  created: string = ""
  source: string = ""
  caseNumber: string = ""
  taskType: number = LeadTaskType.NotDefined
  status: number = LeadTaskStatus.NotDefined
  contactName: string = ""
  contactEmail: string = ""
  contactPhone: string = ""
  files: FileAttachment[] = []
  responsibles: LeadResponsibleModel[] = []
  notes: LeadNoteModel[] = []
  proposalUid: string = ""
  proposalStatus: TaskStatus = TaskStatus.NotDefined
  eusupply_link: string = ""
  tendsign_link: string = ""
  // 7N structured Lead fields (rendered in the 7N Lead Details panel)
  startDate: string = ""
  endDate: string = ""
  role: string = ""
  country: string = ""
  workArrangement: string = ""
  city: string = ""
  numberOfConsultants: string = ""
  hoursPerWeek: string = ""
  experience: string = ""
  employmentType: string = ""

  constructor(
    data: {
      uid: string
      name: string
      description: string
      customerId: string
      customerName: string
      companyVat?: string
      companyCountry?: string
      customerDeadline: string
      created: string
      source: string
      caseNumber: string
      taskType: LeadTaskType
      status: LeadTaskStatus
      contactName: string
      contactEmail: string
      contactPhone: string
      files: any[]
      responsibles: any[]
      notes: any[]
      proposalUid: string
      proposalStatus: TaskStatus
      eusupply_link: string
      tendsign_link: string
      // 7N-only fields — absent on standard leads, so optional.
      startDate?: string
      endDate?: string
      role?: string
      country?: string
      workArrangement?: string
      city?: string
      numberOfConsultants?: string
      hoursPerWeek?: string
      experience?: string
      employmentType?: string
    } | null = null,
  ) {
    if (data) {
      this.uid = data.uid
      this.name = data.name
      this.description = data.description
      this.customerId = data.customerId
      this.customerName = data.customerName
      this.companyVat = data.companyVat ?? ""
      this.companyCountry = data.companyCountry ?? ""
      this.customerDeadline = data.customerDeadline
      this.created = data.created
      this.source = data.source
      this.caseNumber = data.caseNumber
      this.taskType = data.taskType
      this.status = data.status
      this.contactName = data.contactName
      this.contactEmail = data.contactEmail
      this.contactPhone = data.contactPhone
      this.files = data.files
      this.responsibles = data.responsibles
      this.notes = data.notes
      this.proposalUid = data.proposalUid
      this.proposalStatus = data.proposalStatus
      this.eusupply_link = data.eusupply_link
      this.tendsign_link = data.tendsign_link
      this.startDate = data.startDate ?? ""
      this.endDate = data.endDate ?? ""
      this.role = data.role ?? ""
      this.country = data.country ?? ""
      this.workArrangement = data.workArrangement ?? ""
      this.city = data.city ?? ""
      this.numberOfConsultants = data.numberOfConsultants ?? ""
      this.hoursPerWeek = data.hoursPerWeek ?? ""
      this.experience = data.experience ?? ""
      this.employmentType = data.employmentType ?? ""
    }
  }
}
